import { emptyWaveform } from '../../../shared/models/voice-waveform.model';

/**
 * Cosa sta facendo l'audio della lettura ad alta voce, istante per istante. È un solo stato e non tre
 * flussi separati perché le tre cose si leggono sempre insieme: la bolla mostra l'onda finché `playing` è
 * vero, e nel momento in cui smette il testo deve tornare — con sorgenti distinte ci sarebbe un fotogramma
 * in cui l'una dice «finito» e l'altra porta ancora una traccia a metà.
 */
export interface AudioPlaybackState {
  readonly playing: boolean;

  /**
   * L'onda della traccia intera, un livello per barra: c'è tutta da subito, come il disegno di un vocale
   * prima di premere play. Tutti a zero finché la traccia non è stata letta — e in un ambiente che non sa
   * leggerla, per sempre: la lettura si sente lo stesso.
   */
  readonly levels: readonly number[];

  /**
   * A che punto è la riproduzione, in [0, 1]. È ciò che colora l'onda fin dove si è arrivati: senza, la
   * traccia direbbe quanto dura ma non quanto ne resta.
   */
  readonly progress: number;
}

/** Il silenzio: nessuna lettura in corso, nessuna traccia da mostrare e nessun punto a cui essere. */
export const SILENT_PLAYBACK: AudioPlaybackState = {
  playing: false,
  levels: emptyWaveform(),
  progress: 0,
};
